import { render, staticRenderFns } from "./quote_details.vue?vue&type=template&id=4a546d66&"
import script from "./quote_details.vue?vue&type=script&lang=js&"
export * from "./quote_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports